var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGearshift = function SvgGearshift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22252E",
    fillRule: "evenodd",
    d: "M6.569 25.42a13.225 13.225 0 0 0 18.783 0c5.203-5.22 5.36-13.62.156-18.84-5.203-5.218-13.736-5.218-18.94 0a13.32 13.32 0 0 0 0 18.84m16.913-1.884c4.162-4.175 4.287-10.897.125-15.072-4.163-4.174-10.99-4.174-15.152 0a10.656 10.656 0 0 0 0 15.072 10.58 10.58 0 0 0 15.027 0m-8.815-12.982c0-.674.597-1.22 1.333-1.22s1.333.546 1.333 1.22v4.113h1.334c1.041 0 1.333-.292 1.333-1.334v-2.666a1.333 1.333 0 1 1 2.667 0v2.666c0 2.515-1.486 4-4 4h-1.334v4.113c0 .674-.597 1.22-1.333 1.22s-1.333-.546-1.333-1.22v-4.113H12v4.113c0 .674-.597 1.22-1.333 1.22-.737 0-1.334-.546-1.334-1.22V10.554c0-.674.597-1.22 1.334-1.22.736 0 1.333.546 1.333 1.22v4.113h2.667zm8 10.78a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gearshift_svg__a",
    width: 28,
    height: 28,
    x: 2,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.569 25.42a13.225 13.225 0 0 0 18.783 0c5.203-5.22 5.36-13.62.156-18.84-5.203-5.218-13.736-5.218-18.94 0a13.32 13.32 0 0 0 0 18.84m16.913-1.884c4.162-4.175 4.287-10.897.125-15.072-4.163-4.174-10.99-4.174-15.152 0a10.656 10.656 0 0 0 0 15.072 10.58 10.58 0 0 0 15.027 0m-8.815-12.982c0-.674.597-1.22 1.333-1.22s1.333.546 1.333 1.22v4.113h1.334c1.041 0 1.333-.292 1.333-1.334v-2.666a1.333 1.333 0 1 1 2.667 0v2.666c0 2.515-1.486 4-4 4h-1.334v4.113c0 .674-.597 1.22-1.333 1.22s-1.333-.546-1.333-1.22v-4.113H12v4.113c0 .674-.597 1.22-1.333 1.22-.737 0-1.334-.546-1.334-1.22V10.554c0-.674.597-1.22 1.334-1.22.736 0 1.333.546 1.333 1.22v4.113h2.667zm8 10.78a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0",
    clipRule: "evenodd"
  }))));
};
export { SvgGearshift as ReactComponent };